import type { components } from '@/types/openapi';

export type AISettingsDataDTO = components['schemas']['AISettingsResponse'];

// Kept in sync by hand with the backend's AICommunicationLevel enum
// (backend/app/constants.py).
export const AI_COMMUNICATION_LEVELS = [
  { value: 'default', label: 'Default' },
  { value: 'low', label: 'Low' }
] as const;

export type AICommunicationLevel =
  (typeof AI_COMMUNICATION_LEVELS)[number]['value'];

export type AISettingsFormValues = {
  ai_enable_submission: boolean;
  ai_disable_anthropic_models: boolean;
  ai_org_instructions: string;
  ai_ticket_response_instructions: string;
  ai_communication_level: AICommunicationLevel;
  message: string;
};

export type AIAnalystProps = {
  orgLabel: string;
};
